import React, { Component } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
// import ReactToolTip from 'react-tooltip';
import queryString from 'query-string';
import { monthNames, PadMonthIndex } from "utils/dateFormat";
// import iconSlider from "assets/images/icons/icon-slider.svg";
import SwapRight from "assets/images/icons/project-icons/SwapRight.svg";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";
import { ReactComponent as IconRight } from "assets/images/icons/project-icons/arrow_back_dark.svg";
import { Menu } from "@headlessui/react";
import useUrlNavigation from "hooks/useUrlNavigation";
import Maybe from "./Maybe";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


class Filter extends Component {
    state = {
        isFilterActive: false,
        urlParams: {},
        filterMonthYear: {},
        startDate: null,
        selectedTimeframe: "",
        filtersShown: false,
        selectedDateRangeOption: null,
    }

    setSelectedDateRangeOption = (payload) => {
        this.setState({ selectedDateRangeOption: payload });
    }
      
    showFilterIndicator = () => {
        let isFilterActive = false;
        let filterNames = [];
        const {filters} = this.props;
        const qsObject = queryString.parse(this.props.location.search);

        if (filters){
            filters.forEach((filter) => {
                if (filter.name !== undefined){
                    filterNames.push(filter.name);
                }
                else{
                    if (filter.dataType === "number-range" || filter.dataType === "date-range"){
                        filterNames.push(filter.options.from.name);
                        filterNames.push(filter.options.to.name);
                    }
                    else if (filter.dataType === "month-year"){
                        filterNames.push("month");
                        filterNames.push("year");
                    }
                }
            });

            filterNames.forEach((name) => {
                if (qsObject[name] !== undefined){
                    isFilterActive = true;
                }
            });
        }

        this.setState({isFilterActive});
    }

    processUrlParams = () => {
        const params = new URLSearchParams(this.props.location.search);
        const urlParams = Object.fromEntries(params);
        this.setState({
            urlParams: {
                ...urlParams,
            }
        });

        if (urlParams.month && urlParams.year){
            const monthIndex = PadMonthIndex(monthNames.indexOf(urlParams.month) + 1);
            const defaultDate = new Date(urlParams.year + "-" + monthIndex + "-01");
            this.monthYearSelection("month-year", defaultDate);
        }
        else{
            this.monthYearSelection("month-year", null);
        }
    }


    gotoUrlQuery = (params) => {
        const qs = queryString.parse(this.props.location.search);
        const filterParams = {
            ...params,
            page: 1,
        }

        Object.keys(filterParams).forEach((paramName) => {
            delete qs[paramName];
        });

        let qsToUrl = new URLSearchParams(qs).toString();
        qsToUrl = this.props.location.pathname + "?" + ((qsToUrl !== "")? qsToUrl + "&" : "");

        // console.log({qsToUrl});
        Object.keys(filterParams).forEach((paramName) => {
            if (filterParams[paramName] !== ""){
                qsToUrl += paramName + "=" + filterParams[paramName] + "&";
            }
        });

        qsToUrl = qsToUrl.substring(0, qsToUrl.length - 1);
        this.props.history.push(qsToUrl);
    }
    

    submitFormSearch = (e) => {
        e.preventDefault();
        const searchInput = document.querySelector("#search");
        this.gotoUrlQuery({[searchInput.name]: searchInput.value});
    }


    getFilterMonthYearValue = (name) => {
        if (name === "month-year"){
            let month = PadMonthIndex(monthNames.indexOf(this.state.urlParams["month"]) + 1);
            let year = this.state.urlParams["year"];
            return (year + "-" + month);
        }
        return "";
    }


    submitFormFilter = (e) => {
        e.preventDefault();
        const {filterMonthYear, selectedDateRangeOption, urlParams} = this.state;
        let params = { ...urlParams };

        const inputSelect = document.querySelectorAll(".submitFormFilter select option:checked");
        const inputRadio = document.querySelectorAll(".submitFormFilter input[type='radio']:checked");
        const inputDate = document.querySelectorAll(".submitFormFilter input[type='date']");
        const inputNumber = document.querySelectorAll(".submitFormFilter input[type='number']");
        // const inputMonthYear = document.querySelectorAll(".submitFormFilter input[type='month']");

        /* inputSelect.forEach(function (ele, index) {
            params[ele.id] = ele.value;
        })
        inputRadio.forEach(function (ele, index) {
            params[ele.name] = ele.value;
        })
        inputDate.forEach(function (ele, index) {
            params[ele.name] = ele.value;
        })
        inputNumber.forEach(function (ele, index) {
            params[ele.name] = ele.value;
        }) */
        /*
        inputMonthYear.forEach(function (ele, index) {
            const name = ele.name.split("-");
            if (ele.value !== ""){
                let d = new Date(ele.value);
                params[name[0]] = MonthName('' + (d.getMonth() + 1));
                if (name[1]){
                    params[name[1]] = '' + d.getFullYear();
                }
            }
            else{
                params[name[0]] = "";
                params[name[1]] = "";
            }
        })
        */
        if (Object.keys(filterMonthYear).length > 0){
            for (let key in filterMonthYear){
                if (key === "month-year"){
                    params["month"] = filterMonthYear[key]["month"];
                    params["year"] = filterMonthYear[key]["year"];
                }
            }
        }
        
        if (selectedDateRangeOption !== null) {
            const { startDate, endDate } = this.getStartAndEndDate(selectedDateRangeOption)
            params["startDate"] = startDate;
            params["endDate"] = endDate;
        }
        this.gotoUrlQuery(params);
        this.setState({filtersShown: !this.state.filtersShown})
    }

    getStartAndEndDate = (period) => {
        // Get the current date
        const endDate = new Date();
    
        // Create a new date object for the start date
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - period);
    
        // Format the dates to "YYYY-MM-DD"
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
    
        return {
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
        };
    }
    
    clearFilter = () => {
        const qsObject = queryString.parse(this.props.location.search);
        // const preserveObjects = ["page", "limit", "employerId"];
        const preserveObjects = ["search", "limit", "employerId"];

        Object.keys(qsObject).forEach((qsObjectName) => {
            if (!preserveObjects.includes(qsObjectName)){
                delete qsObject[qsObjectName];
            }
        });

        // document.querySelector("#search").value = "";

        const inputSelect = document.querySelectorAll(".submitFormFilter select option:checked");
        const inputRadio = document.querySelectorAll(".submitFormFilter input[type='radio']:checked");
        const inputDate = document.querySelectorAll(".submitFormFilter input[type='date']");
        const inputNumber = document.querySelectorAll(".submitFormFilter input[type='number']");
        // const inputMonthYear = document.querySelectorAll(".submitFormFilter input[type='month']");
        
        inputSelect.forEach(function (ele, index) {
            ele.value = "";
        })
        inputRadio.forEach(function (ele, index) {
            ele.checked = !ele.checked;
        })
        inputDate.forEach(function (ele, index) {
            ele.value = "";
        })
        inputNumber.forEach(function (ele, index) {
            ele.value = "";
        })
        // inputMonthYear.forEach(function (ele, index) {
        //     ele.value = "";
        // })
        this.monthYearSelection("",null);
        this.setState({selectedTimeframe: ""})
            
        let qsToUrl = new URLSearchParams(qsObject).toString();
        qsToUrl = this.props.location.pathname + "?" + ((qsToUrl !== "")? qsToUrl + "&" : "");
        qsToUrl = qsToUrl.substring(0, qsToUrl.length - 1);
        this.props.history.push(qsToUrl);
    }
    
    deleteUrlParamsProp = (property) => {
        const { [property]: _, ...newUrlParams } = this.state.urlParams;
        this.setState({ urlParams: newUrlParams });
    }
    
    resetSingleFilter = (queryParam) => {
        const qsObject = queryString.parse(this.props.location.search);
        const preserveObjects = ["search", "limit", "employerId"]
        const { selectedDateRangeOption, filterMonthYear, urlParams }  = this.state;
        
        if (queryParam.dataType === "date-range") {
            const dateFromName = queryParam.options.from.name;
            const dateToName = queryParam.options.to.name;
            if (!preserveObjects.includes(dateFromName) || !preserveObjects.includes(dateToName)) {
                delete qsObject[dateFromName];           
                delete qsObject[dateToName];           
            }
            
            if (dateFromName in urlParams || dateToName in urlParams) {
                const { [dateFromName]: _, [dateToName]: __, ...newUrlParams } = this.state.urlParams;
                this.setState({ urlParams: newUrlParams });
            }
        } else if (queryParam.dataType === "number-range") {
            if (!preserveObjects.includes("selectedDateRangeOption")) {
                delete qsObject[selectedDateRangeOption];
            }
            
            if (selectedDateRangeOption) {
                this.setState({ selectedDateRangeOption: null });
            }
        } else if (queryParam.dataType === "month-year") {
            if (!preserveObjects.includes("filterMonthYear")) {
                delete qsObject[filterMonthYear];
            }
            
            if (filterMonthYear?.[queryParam.option.name]?.fullDate) {
                this.setState({ filterMonthYear: {} });
            }
        } else {
            const filterParamName = queryParam.name;
            if (!preserveObjects.includes(filterParamName)) {
                delete qsObject[filterParamName];           
            }
            
            if (filterParamName in urlParams) {
                this.deleteUrlParamsProp(filterParamName);
            }
        }
        let qsToUrl = new URLSearchParams(qsObject).toString();
        qsToUrl = this.props.location.pathname + "?" + ((qsToUrl !== "")? qsToUrl + "&" : "");
        qsToUrl = qsToUrl.substring(0, qsToUrl.length - 1);
        this.props.history.push(qsToUrl);
    }


    renderMonthContent = (month, shortMonth, longMonth) => {
        const tooltipText = `Tooltip for month: ${longMonth}`;
        return <span title={tooltipText}>{shortMonth}</span>;
    };


    monthYearSelection = (name, valueDate) => {
        this.setState({"startDate": valueDate});
        if (valueDate !== "" && valueDate !== null){
            const filterMonthYear = {
                ...this.state.filterMonthYear,
                [name]: {
                    month: moment(valueDate).format('MMMM'),
                    year: moment(valueDate).format('yy'),
                    fullDate: valueDate,
                },
            }
            this.setState({filterMonthYear})
        }
    }


    componentDidMount() {
        this.processUrlParams();
        this.showFilterIndicator();
    }


    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.processUrlParams();
            this.showFilterIndicator();
        }
    }


    render() { 
        const { isFilterActive, urlParams, startDate, selectedTimeframe, filtersShown, selectedDateRangeOption } = this.state;
        const { filters } = this.props;
        
        const toggleFilterDisplay = () => this.setState({filtersShown: !this.state.filtersShown})
        
        return ( 
            <form onSubmit={this.submitFormFilter} className="submitFormFilter">
                <Menu as="div">
                    <Menu.Button  onClick={toggleFilterDisplay} className="h-full btn px-3 text-sm border border-gray-300 relative focus:ring-transparent" data-tip data-for={isFilterActive ? "filter" : ""}>
                        <span className='px-3'>Filter</span>
                        {/* <img src={iconSlider} alt="filter" className="h-3.5 m-auto object-contain" /> */}

                        {/* 
                        {isFilterActive &&
                            <>
                                <div className="w-3 h-3 absolute -top-1 -right-1 rounded-full bg-red-500" ></div>
                                <ReactToolTip id="filter" className="tooptip-size">
                                    Filter is active
                                </ReactToolTip>
                            </>
                        }
                        */}
                    </Menu.Button>

                    {filters && filtersShown &&
                        <Menu.Items as="div" className={`dropdown ${this.props.dropdownClass || ""}`} style={{maxWidth:"none", overflow: "visible"}}>
                            <div className="w-full p-4 text-sm">
                                
                                <div className='pb-2 mb-4 border-b border-gray-200'>
                                    <div className="flex items-center justify-between">
                                        <div className="lg:text-lg font-medium">
                                            Filter By
                                        </div>
                                        
                                        <div onClick={toggleFilterDisplay} className='w-7 h-7 bg-[#f4f4f4] cursor-pointer rounded-xl flex items-center justify-center'>
                                            <IconsTimes width={25} />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="mt-3">
                                    {filters?.map((filter, index) =>
                                        <div key={index} className="pb-3">
                                            <div className="mb-2 flex items-center justify-between w-full">
                                                {filter.title}
                                                
                                                {/* <Maybe condition={filter.dataType === 'custom-timeframe'}>
                                                    <button 
                                                        onClick={() => { 
                                                            this.resetSingleFilter(filter.name); 
                                                            this.setState({selectedTimeframe: ""});
                                                        }} 
                                                        type="button" 
                                                        className='text-ep-primary-600 text-xs'
                                                    >
                                                        Reset
                                                    </button>
                                                </Maybe>
                                                
                                                <Maybe condition={filter.dataType !== 'custom-timeframe'}>
                                                    <button 
                                                        onClick={this.clearFilter} 
                                                        type="button" 
                                                        className='text-ep-primary-600 text-xs'
                                                    >
                                                        Reset
                                                    </button>
                                                </Maybe> */}
                                                <button 
                                                    onClick={() => { 
                                                        this.resetSingleFilter(filter); 
                                                    }} 
                                                    type="button" 
                                                    className='text-ep-primary-600 text-xs'
                                                >
                                                    Reset
                                                </button>
                                            </div>
                                            <div className="w-full my-3">
                                                
                                                {filter.dataType === 'custom-timeframe' &&
                                                    <div className="flex items-center justify-between w-full">
                                                        {filter?.options?.map((option, index2) => {
                                                            const isActive = urlParams[filter.name] === option.payload.toString() /* selectedTimeframe === option.payload || (!urlParams[filter.name] && option.payload === "") */;
                                                            
                                                            return (
                                                            <label 
                                                                onClick={() => this.setState({
                                                                    urlParams: {
                                                                        ...this.state.urlParams,
                                                                        [filter.name]: option.payload,
                                                                    }
                                                                })} 
                                                                key={index2} className="cursor-pointer"
                                                            >
                                                                <input type="radio"
                                                                    name={filter.name}
                                                                    // value={option.payload}
                                                                    value={urlParams[filter.name]}
                                                                    defaultChecked={isActive}
                                                                    style={{display: 'none'}}
                                                                /> 
                                                                <span className={`transition-colors whitespace-nowrap px-2.5 py-1 flex items-center justify-center border rounded-md text-sm
                                                                     ${isActive ? "text-ep-primary-600 border-ep-primary-600" : "text-[#667085] border-[#d0d5dd]"}`}>
                                                                    {option.display}
                                                                </span>
                                                            </label>
                                                            )
                                                        })}
                                                    </div>
                                                }
                                                
                                                {filter?.dataType === "select" &&
                                                    <div className="box-border-only border-gray-300">
                                                        <div className="form-group mb-0">
                                                            <select 
                                                                name={filter?.name} 
                                                                value={urlParams?.[filter.name] || ""}
                                                                className="form-input" 
                                                                onChange={(evt) => {
                                                                    this.setState({
                                                                        urlParams: {
                                                                            ...this.state.urlParams,
                                                                            [filter.name]: evt.target.value,
                                                                        }
                                                                    })
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {filter?.options?.map((option, index2) => (
                                                                    <option 
                                                                        key={index2} 
                                                                        id={filter.name} 
                                                                        value={option.payload}
                                                                    >
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                }

                                                {filter?.dataType === "radio" &&
                                                    <div className="grid grid-cols-2 gap-x-4 gap-y-2">
                                                        {filter?.options?.map((option, index2) => 
                                                            <label key={index2} className="flex space-x-1.5 cursor-pointer">
                                                                <input type="radio"
                                                                    name={filter.name}
                                                                    value={option.payload}
                                                                    checked={(urlParams[filter.name] === option.payload.toString()) || (!urlParams[filter.name] && option.payload === "")}
                                                                    className="my-auto form-radio"
                                                                    onChange={() => {
                                                                        this.setState({
                                                                            urlParams: {
                                                                                ...this.state.urlParams,
                                                                                [filter.name]: option.payload,
                                                                            }
                                                                        })
                                                                    }}
                                                                /> 
                                                                <span className="my-auto">
                                                                    {option.display}
                                                                </span>
                                                            </label>
                                                        )}
                                                    </div>
                                                }

                                                {filter.dataType === "month-year" &&
                                                    <div className="box-border-only border-gray-300">
                                                        <div className="form-group mb-0">
                                                            <div className="custom-date-picker">
                                                                <DatePicker
                                                                    selected={startDate}
                                                                    renderMonthContent={this.renderMonthContent}
                                                                    showMonthYearPicker
                                                                    dateFormat="MMMM, yyyy"
                                                                    placeholderText={filter.option.placeholder}
                                                                    className="form-input"
                                                                    onChange={(date) => this.monthYearSelection(filter.option.name, date)}
                                                                    value={this.state.filterMonthYear[filter.option.name]?.fullDate || ""}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                {filter.dataType === "date-range" &&
                                                    <div className="flex items-center box-border-only border-gray-300">
                                                        <div className="form-group mb-0 flex-grow">
                                                            <input type="date"
                                                                name={filter.options.from.name}
                                                                placeholder={filter.options.from.placeholder}
                                                                defaultValue={urlParams[filter.options.from.name]}
                                                                value={urlParams[filter.options.from.name] || ""}
                                                                className="form-input"
                                                                onChange={(evt) => {
                                                                    this.setState({
                                                                        urlParams: {
                                                                            ...this.state.urlParams,
                                                                            [filter.options.from.name]: evt.target.value,
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="flex-shrink-0 flex rotate-180 mx-2">
                                                            <IconRight width={10} />
                                                        </div>
                                                        <div className="form-group mb-0 flex-grow">
                                                            <input type="date"
                                                                name={filter.options.to.name}
                                                                placeholder={filter.options.to.placeholder}
                                                                value={urlParams[filter.options.to.name] || ""}
                                                                className="form-input"
                                                                onChange={(evt) => {
                                                                    this.setState({
                                                                        urlParams: {
                                                                            ...this.state.urlParams,
                                                                            [filter.options.to.name]: evt.target.value,
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                }

                                                {filter?.dataType === "number-range" &&
                                                        <div className="flex cursor-pointer justify-between">
                                                                {filter?.options?.map((option, index2) =>
                                                                    <div 
                                                                        key={index2} 
                                                                        className={`box-border-only border p-2 rounded bg-[#FFFFFF] ${selectedDateRangeOption == option.payload ? "border-[#00535C]" : "border-gray-300" }`} 
                                                                        onClick={() => {
                                                                            this.setSelectedDateRangeOption(option.payload)}
                                                                        } 
                                                                        id={filter.name} 
                                                                        value={option.payload}
                                                                    >
                                                                        {option.display}
                                                                    </div>
                                                                )}
                                                        </div>
                                                }
                                                {/* {filter.dataType === "number-range" &&
                                                    <div className="flex box-border-only border-gray-300">
                                                        <div className="form-group mb-0 flex-grow">
                                                            <input type="number"
                                                                name={filter.options.from.name}
                                                                placeholder={filter.options.from.placeholder}
                                                                defaultValue={urlParams[filter.options.from.name]}
                                                                className="form-input"
                                                                // style={{width: "100px", border: "none"}}
                                                            />
                                                        </div>
                                                        <div className="w-7 flex-shrink-0 flex">
                                                            <img src={SwapRight} alt="arrow" className="m-auto h-5" />
                                                        </div>
                                                        <div className="form-group mb-0 flex-grow">
                                                            <input type="number"
                                                                name={filter.options.to.name}
                                                                placeholder={filter.options.to.placeholder}
                                                                defaultValue={urlParams[filter.options.to.name]}
                                                                className="form-input"
                                                                // style={{width: "100px", border: "none"}}
                                                            />
                                                        </div>
                                                    </div>
                                                } */}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="mt-2 pt-4 pb-0 flex space-x-3 justify-end text-lg border-t border-gray-200">
                                    <Menu.Button as="button" type="button" className="btn btn-md btn-transparent-primary">
                                        Cancel
                                    </Menu.Button>
                                    <button type="submit" className="btn btn-md btn-ep-primary">
                                        Apply
                                    </button>
                                </div>

                            </div>
                        </Menu.Items>
                    }
                </Menu>
            </form>
        );
    }
}



export const ActiveFilter = (props) => {
    const history = useHistory();
    const {getUrlQueries, removeUrlQuery} = useUrlNavigation();


    let activeFilters = [];
    if (props.filters){
        Object.keys(props?.filters)?.map((key) => {
            if (getUrlQueries()[props?.filters[key]] !== undefined){
                activeFilters.push({
                    key: key,
                    value: props.filters[key],
                })
            }
            else{
                if (key === "Month & Year"){
                    if (getUrlQueries()["month"] !== undefined || getUrlQueries()["year"] !== undefined){
                        activeFilters.push({
                            key: key,
                            value: props.filters[key],
                        })
                    }
                }
            }
            return null;
        })
    }


    const removeFilter = (value) => {
        if (value === "month-year"){
            history.push(removeUrlQuery(["month","year"]));
        }
        else{
            history.push(removeUrlQuery([value]));
        }
    }


    return (
        <>
            <Maybe condition={activeFilters?.length > 0}>
                <div className="mt-2 flex flex-wrap">
                    {activeFilters?.map((filter, index) => 
                        <div key={index} className="px-2 py-1 mt-4 mr-4 flex items-center bg-ep-primary-500 bg-opacity-10 rounded-lg">
                            <div className="text-ep-primary">
                                {filter.key}
                            </div>
                            <div onClick={() => removeFilter(filter.value)} className="h-full px-1 ml-2 flex hover:bg-red-500 rounded-md group cursor-pointer">
                                <IconsTimes className="m-auto group-hover:svg-fill-white" />
                            </div>
                        </div>
                    )}
                </div>
            </Maybe>
        </>
    )
}



export default withRouter(Filter);
